export class UnauthorizedError extends Error {
  override readonly name = 'UnauthorizedError';
  constructor() {
    super('Unauthorized');
  }
}

export class NetworkError extends Error {
  override readonly name = 'NetworkError';
  constructor() {
    super('Network error');
  }
}

export class ServerError extends Error {
  override readonly name = 'ServerError';
  constructor() {
    super('Server error');
  }
}

/** The slot, one-off, occurrence, or template the request named is gone. */
export class ScheduleNotFoundError extends Error {
  override readonly name = 'ScheduleNotFoundError';
  constructor(message = 'Schedule entry not found') {
    super(message);
  }
}

/** The change conflicts with the schedule's current state (a live workout, a closed slot). */
export class ScheduleConflictError extends Error {
  override readonly name = 'ScheduleConflictError';
  constructor(message = 'Schedule conflict') {
    super(message);
  }
}

/** The server refused the change itself, e.g. moving an occurrence to its own date. */
export class ScheduleRejectedError extends Error {
  override readonly name = 'ScheduleRejectedError';
  constructor(message = 'Schedule change rejected') {
    super(message);
  }
}

export class InvalidScheduleInputError extends Error {
  override readonly name = 'InvalidScheduleInputError';
  constructor(message = 'Invalid schedule input') {
    super(message);
  }
}

export type ScheduleError =
  | UnauthorizedError
  | NetworkError
  | ServerError
  | ScheduleNotFoundError
  | ScheduleConflictError
  | ScheduleRejectedError
  | InvalidScheduleInputError;
